import { Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ObjectPaymentReportRow } from '@econtractor/types';
import { usePaymentReport } from '../context/ReportObjectPaymentsProvider';
import { paymentColumns } from '../model/reportObjectPayments';
import ReportObjectPaymentsTableBody from './ReportObjectPaymentsTableBody';

const classes = ['head-name', 'head-username', 'head-username', 'head-date', 'head-amount text-end', 'head-file'];

const ReportObjectPaymentsTable = ({ rows }: { rows: ObjectPaymentReportRow[] }) => {
    const { t } = useTranslation(['Reports']);
    const report = usePaymentReport();
    return (
        <div className="crm-table-wrap">
            <Table className="ReportObjectPaymentsTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        {paymentColumns.map((column, index) => column === 'name' && report.objectId !== undefined ? null : (
                            <td key={column} role="columnheader" className={classes[index]} aria-sort={report.sortKey === column && !report.filters.detail ? report.direction === 'asc' ? 'ascending' : 'descending' : 'none'}>
                                {report.filters.detail ? t(`objectPayments.columns.${column}`) : (
                                    <Button variant="link" className={`p-0 text-body text-decoration-none ${column === 'amount' ? 'text-end' : 'text-start'}`} onClick={() => report.sort(column)}>
                                        {t(`objectPayments.columns.${column}`)} {report.sortKey === column ? report.direction === 'asc' ? '↑' : '↓' : ''}
                                    </Button>
                                )}
                            </td>
                        ))}
                    </tr>
                </thead>
                <ReportObjectPaymentsTableBody rows={rows} />
            </Table>
        </div>
    );
};

export default ReportObjectPaymentsTable;
